// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import FullscreenProvider, { useFullscreenContext } from './FullscreenProvider';

export { useFullscreenContext };

export default FullscreenProvider;
